import { InvoicesCommandVersionsService_invoiceCommandVersionsServiceGetQuery } from '@festina/moneyin-general-types/moneyin/hooks/InvoicesCommandVersionsService_invoiceCommandVersionsServiceGetQuery'

export const useLazyFetchInvoiceCommandVersions =
  InvoicesCommandVersionsService_invoiceCommandVersionsServiceGetQuery.useLazyQuery
